var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.592 0 0 3.592 0 8C0 12.408 3.592 16 8 16C12.408 16 16 12.408 16 8C16 3.592 12.408 0 8 0ZM11.768 6.968L7.768 10.968C7.608 11.12 7.408 11.2 7.2 11.2C6.992 11.2 6.792 11.12 6.632 10.968L4.232 8.568C3.92 8.256 3.92 7.744 4.232 7.432C4.544 7.12 5.056 7.12 5.368 7.432L7.2 9.272L10.632 5.832C10.944 5.52 11.456 5.52 11.768 5.832C12.08 6.144 12.08 6.656 11.768 6.968Z",
    fill: "#1EBB8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateV2);
export default __webpack_public_path__ + "static/media/activate-v2.8e81730bf91b026ccb24ba8cec7496f2.svg";
export { ForwardRef as ReactComponent };